import React, { createContext, useState, useContext, ReactNode, useEffect } from 'react';
import { dataFakeForLoading, initialViewMode, VIEW_MODE_LIST } from '../Utils/Constants/Product';
import { isArraysEqual, isValidViewMode } from '../Utils/Helpers';
import { useTranslation } from 'react-i18next';

interface LayoutType {
  mainLoading: boolean;
  setMainLoading: CallableFunction;
  mainLoadingIcon: boolean;
  setMainLoadingIcon: CallableFunction;
  mainLoadingIconInfo: boolean;
  setMainLoadingIconInfo: CallableFunction;
  mainLoadingIconSuccess: boolean;
  setMainLoadingIconSuccess: CallableFunction;
  mainLoadingIconError: boolean;
  setMainLoadingIconError: CallableFunction;
  mainLoadingIconSearch: boolean;
  setMainLoadingIconSearch: CallableFunction;
  mainLoadingIconNoSearchMap: boolean;
  setMainLoadingIconNoSearchMap: CallableFunction;
  mainLoadingIconNoSearchUser: boolean;
  setMainLoadingIconNoSearchUser: CallableFunction;
  mainLoadingIconClick: boolean;
  setMainLoadingIconClick: CallableFunction;
  mainLoadingIconMapCheck: boolean;
  setMainLoadingIconMapCheck: CallableFunction;
  mainLoadingTitle: string;
  setMainLoadingTitle: CallableFunction;
  mainLoadingMessage: string;
  setMainLoadingMessage: CallableFunction;
  mainLoadingCloseButton: boolean;
  setMainLoadingCloseButton: CallableFunction;
  mainLoadingLabelCloseButton: string;
  setMainLoadingLabelCloseButton: CallableFunction;
  mainLoadingIconErrorAddProduct: boolean;
  setMainLoadingIconErrorAddProduct: CallableFunction;
  enabledCartLoad: boolean;
  setEnabledCartLoad: CallableFunction;
  mainLoadingIconSearchCart: boolean;
  setMainLoadingIconSearchCart: CallableFunction;
  mainLoadingIconStoreClosed: boolean;
  setMainLoadingIconStoreClosed: CallableFunction;
  mainLoadingAutoClose: boolean;
  setMainLoadingAutoClose: CallableFunction;
  isMobile: boolean;
  isOnline: boolean;
  setIsOnline: CallableFunction;
  hasError: boolean;
  setHasError: CallableFunction;
  productsToSearch: any;
  setProductsToSearch: CallableFunction;
  categories: any;
  setCategories: CallableFunction;
  loadingCategories: any;
  setLoadingCategories: CallableFunction;
  allCategories: any;
  setAllCategories: CallableFunction;
  banners: any;
  setBanners: CallableFunction;
  featuredProducts: any;
  setFeaturedProducts: CallableFunction;
  viewMode: string;
  setViewMode: (value: string) => void;
  currentSwiperSlide: number;
  setCurrentSwiperSlide: (value: number) => void;
  welcomeScreenRead: boolean;
  setWelcomeScreenRead: (value: boolean) => void;
  isGeolocationAllowed: boolean;
  setIsGeolocationAllowed: (value: boolean) => void;
  isCategoriesSwiperViewed: boolean;
  setIsCategoriesSwiperViewed: (value: boolean) => void;
  isCartInfoViewed: boolean | null;
  setIsCartInfoViewed: (value: boolean | null) => void;
  company: any;
  setCompany: CallableFunction;
  setLoadingCompany: CallableFunction;
  companyPages: any;
  setCompanyPages: CallableFunction;
  loadingCompany: boolean; 
  versionFront: any;
  setVersionFront: CallableFunction;
  states: any;
  setStates: CallableFunction;
  boxHeightMethodPayment: number;
  setBoxHeightMethodPayment: CallableFunction;
  showSearchBar: boolean;
  setShowSearchBar: (value: boolean) => void;
  showTodayOrders: boolean;
  setShowTodayOrders: (value: boolean) => void;
  showMainMenu: boolean;
  setShowMainMenu: (value: boolean) => void;
  showStart: boolean;
  setShowStart: (value: boolean) => void;
  enableLoadProducts: boolean;
  setEnableLoadProducts: (value: boolean) => void;
  currentPosition: any;
  setCurrentPosition: (value: any) => void;
}

const LayoutContext = createContext<LayoutType | undefined>(undefined);

export const LayoutProvider = ({ children }: { children: ReactNode }) => {

  const { t } = useTranslation();
  const [mainLoading, setMainLoading] = useState(false);
  const [mainLoadingIcon, setMainLoadingIcon] = useState(true);
  const [mainLoadingIconInfo, setMainLoadingIconInfo] = useState(false);
  const [mainLoadingIconSuccess, setMainLoadingIconSuccess] = useState(false);
  const [mainLoadingIconError, setMainLoadingIconError] = useState(false);
  const [mainLoadingIconSearch, setMainLoadingIconSearch] = useState(false);
  const [mainLoadingIconSearchCart, setMainLoadingIconSearchCart] = useState(false);
  const [mainLoadingIconStoreClosed, setMainLoadingIconStoreClosed] = useState(false);
  const [mainLoadingIconNoSearchMap, setMainLoadingIconNoSearchMap] = useState(false);
  const [mainLoadingIconNoSearchUser, setMainLoadingIconNoSearchUser] = useState(false);
  const [mainLoadingIconMapCheck, setMainLoadingIconMapCheck] = useState(false);
  const [mainLoadingIconClick, setMainLoadingIconClick] = useState(false);
  const [mainLoadingTitle, setMainLoadingTitle] = useState(t('layout.confirm.loading'));
  const [mainLoadingMessage, setMainLoadingMessage] = useState('');
  const [mainLoadingCloseButton, setMainLoadingCloseButton] = useState(false);
  const [mainLoadingLabelCloseButton, setMainLoadingLabelCloseButton] = useState(t('layout.confirm.label_close_button'));
  const [mainLoadingIconErrorAddProduct, setMainLoadingIconErrorAddProduct] = useState(false);
  const [enabledCartLoad, setEnabledCartLoad] = useState(true);
  const [hasError, setHasError] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [currentSwiperSlide, setCurrentSwiperSlide] = useState(() => {
    return 0;
    // const storedValue = localStorage.getItem('current_swiper_slide');
    // return storedValue ? parseInt(storedValue, 10) : 0;
  });
  const [company, setCompany] = useState(null)
  const [loadingCompany, setLoadingCompany] = useState<boolean>(false)
  const [companyPages, setCompanyPages] = useState(null)
  const [states, setStates] = useState<any[]>([]);
  const [versionFront, setVersionFront] = useState(() => localStorage.getItem('version') || null)
  const [productsToSearch, setProductsToSearch] = useState<any[]>([]);
  const [categories, setCategories] = useState<any[]>(dataFakeForLoading);
  const [ loadingCategories, setLoadingCategories ] = useState<boolean>(isArraysEqual(categories, dataFakeForLoading));
  const [featuredProducts, setFeaturedProducts] = useState<any[]>(dataFakeForLoading);
  const [allCategories, setAllCategories] = useState<any[]>([]);
  const [banners, setBanners] = useState<any[]>(dataFakeForLoading);
  const [boxHeightMethodPayment, setBoxHeightMethodPayment] = useState<number>(0);
  const [showSearchBar, setShowSearchBar] = useState(false);
  const [showTodayOrders, setShowTodayOrders] = useState(false);
  const [showMainMenu, setShowMainMenu] = useState(false);
  const [showStart, setShowStart] = useState(false);

  const [enableLoadProducts, setEnableLoadProducts] = useState(true);
  const [currentPosition, setCurrentPosition] = useState(null);

  const [viewMode, setViewMode] = useState(() => {
    const storedValue = localStorage.getItem('view_mode');
    return storedValue && isValidViewMode(storedValue) ? storedValue : initialViewMode;
  });

  const [welcomeScreenRead, setWelcomeScreenRead] = useState<boolean>(() => {
    const storedValue = localStorage.getItem('welcome_read');
    return storedValue === 'true';
  });
  const [isCategoriesSwiperViewed, setIsCategoriesSwiperViewed] = useState<boolean>(() => {
    const storedValue = localStorage.getItem('categories_swiper_viewed');
    return storedValue === 'true';
  });
  const [isCartInfoViewed, setIsCartInfoViewed] = useState<boolean | null>(() => {
    const storedValue = localStorage.getItem('cart_info_viewed');
    return storedValue !== null ? storedValue === 'true' : null;
  });
  const [isGeolocationAllowed, setIsGeolocationAllowed] = useState<boolean>(() => {
    const storedValue = localStorage.getItem('geolocation_allowed');
    return storedValue === 'true';
  });
  const [mainLoadingAutoClose, setMainLoadingAutoClose] = useState(false);

  useEffect(() => {
    localStorage.setItem('geolocation_allowed', String(isGeolocationAllowed))
  }, [isGeolocationAllowed])

  useEffect(() => {
    if (isCartInfoViewed) {
      localStorage.setItem('cart_info_viewed', 'true')
    }
  }, [isCartInfoViewed])

  useEffect(() => {
    localStorage.setItem('view_mode', viewMode)
    if (viewMode === VIEW_MODE_LIST) {
      setIsCategoriesSwiperViewed(true);
    }
  }, [viewMode])

  useEffect(() => {
    localStorage.setItem('current_swiper_slide', currentSwiperSlide.toString())
  }, [currentSwiperSlide])

  useEffect(() => {
    if (versionFront) {
      localStorage.setItem('version', versionFront)
    } else {
      localStorage.removeItem('version')
    }
  }, [versionFront])

  useEffect(() => {
    localStorage.setItem('welcome_read', welcomeScreenRead.toString());
  }, [welcomeScreenRead]);

  useEffect(() => {
    localStorage.setItem('categories_swiper_viewed', isCategoriesSwiperViewed.toString());
  }, [isCategoriesSwiperViewed]);

  useEffect(() => {
    if (mainLoading === false) {
      setTimeout(() => { //* only for layout
        setMainLoadingIcon(true);
        setMainLoadingIconInfo(false);
        setMainLoadingIconSuccess(false);
        setMainLoadingIconError(false);
        setMainLoadingIconSearch(false);
        setMainLoadingIconNoSearchMap(false);
        setMainLoadingIconNoSearchUser(false);
        setMainLoadingIconMapCheck(false);
        setMainLoadingIconClick(false);
        setMainLoadingTitle('');
        setMainLoadingMessage('');
        setMainLoadingLabelCloseButton(t('layout.confirm.label_close_button'));
        setMainLoadingCloseButton(false);
        setMainLoadingIconErrorAddProduct(false);
        setHasError(false);
        setMainLoadingIconSearchCart(false);
        setMainLoadingIconStoreClosed(false);
        setMainLoadingAutoClose(false);
      }, 250);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mainLoading])

  useEffect(() => {
    window.addEventListener('resize', () => {
        setIsMobile(window.innerWidth < 768)
    })
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };

  }, [])

  return (
    <LayoutContext.Provider value={{
        mainLoading, setMainLoading,
        mainLoadingIcon, setMainLoadingIcon,
        mainLoadingIconInfo, setMainLoadingIconInfo,
        mainLoadingIconSuccess, setMainLoadingIconSuccess,
        mainLoadingIconError, setMainLoadingIconError,
        mainLoadingIconSearch, setMainLoadingIconSearch,
        mainLoadingIconNoSearchMap, setMainLoadingIconNoSearchMap,
        mainLoadingIconNoSearchUser, setMainLoadingIconNoSearchUser,
        mainLoadingIconMapCheck, setMainLoadingIconMapCheck,
        mainLoadingIconClick, setMainLoadingIconClick,
        mainLoadingTitle, setMainLoadingTitle,
        mainLoadingMessage, setMainLoadingMessage,
        mainLoadingCloseButton, setMainLoadingCloseButton,
        mainLoadingIconErrorAddProduct, setMainLoadingIconErrorAddProduct,
        enabledCartLoad, setEnabledCartLoad,
        mainLoadingIconSearchCart, setMainLoadingIconSearchCart,
        mainLoadingIconStoreClosed, setMainLoadingIconStoreClosed,
        mainLoadingLabelCloseButton, setMainLoadingLabelCloseButton,
        mainLoadingAutoClose, setMainLoadingAutoClose,
        isMobile,
        viewMode, setViewMode,
        currentSwiperSlide, setCurrentSwiperSlide,
        isOnline, setIsOnline,
        hasError, setHasError,
        productsToSearch, setProductsToSearch,
        categories, setCategories,
        loadingCategories, setLoadingCategories,
        allCategories, setAllCategories,
        banners, setBanners,
        featuredProducts, setFeaturedProducts,
        welcomeScreenRead, setWelcomeScreenRead,
        isGeolocationAllowed, setIsGeolocationAllowed,
        isCategoriesSwiperViewed, setIsCategoriesSwiperViewed,
        isCartInfoViewed, setIsCartInfoViewed,
        company, setCompany,
        loadingCompany, setLoadingCompany,
        companyPages, setCompanyPages,
        versionFront, setVersionFront,
        states, setStates,
        boxHeightMethodPayment, setBoxHeightMethodPayment,
        showSearchBar, setShowSearchBar,
        showTodayOrders, setShowTodayOrders,
        showMainMenu, setShowMainMenu,
        showStart, setShowStart,
        enableLoadProducts, setEnableLoadProducts,
        currentPosition, setCurrentPosition
      }}>
      {children}
    </LayoutContext.Provider>
  );
};

export const useLayoutContext = () => {
  const context = useContext(LayoutContext);
  if (!context) {
    throw new Error('useModal must be used within a ModalProvider');
  }
  return context;
};
